import { storageUtils } from '@/lib/storageUtils';
import type { OceanOfferType } from '../components/OceanOfferFace';

const STORAGE_KEY = 'preliminary-offer:choice';
// KYC and the ANAF check can take a day or more: long enough to continue
// with the chosen credit once the final offer is in.
const CHOICE_TTL_MS = 72 * 60 * 60 * 1000;

// The preliminary credit the user went to KYC with.
export interface PreliminaryChoice {
  userId: string;
  type: OceanOfferType;
  amount: number;
  numberOfRates?: number;
  // The preliminary offer as chosen, compared with the final one.
  offer: {
    creditLimit: number;
    effectiveAnnualPercentageRate: number;
  };
}

export const preliminaryChoiceStorage = {
  save: (choice: PreliminaryChoice) =>
    storageUtils.set(STORAGE_KEY, choice, CHOICE_TTL_MS),

  // Another account signed in on the same device has no choice.
  get: (userId: string | undefined): PreliminaryChoice | null => {
    const choice = storageUtils.get<PreliminaryChoice>(STORAGE_KEY);
    return choice && userId && choice.userId === userId ? choice : null;
  },

  clear: () => storageUtils.remove(STORAGE_KEY),
};
